<div [uiGutter]="12" ui-row>
  <kpi-statistics-card *ngFor="let statistic of statisticList" [statistic]="statistic" [uiXs]="8" [isEmptyState]="isEmptyState$() | async" ui-col></kpi-statistics-card>
</div>
